<div class="container">
  <div>
    <section class="header">
      <img class="pointer" src="/assets/img/logos/_manual_ledger.svg" alt="waltio" [routerLink]="'/dashboard'" />
    </section>

    <section class="main">
      <div class="infos">
        @if (showNextFiscalYearUpgrade) {
          <button mat-flat-button type="button" color="primary" disableRipple (click)="openSwitchFiscalYearDialog()">
            {{ moveToFiscalYearLabel }}
          </button>
        }

        @if (assessmentStatus) {
          <app-assessment-status
            [assessment]="assessment"
            [assessmentStatus]="assessmentStatus"
            [assessmentETA]="assessmentETA"
            [user]="user"
            (statusClick)="assessmentStatusClick()"
          ></app-assessment-status>
        } @else {
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{
              'border-radius': '6px',
              'width': '221px',
              'height': '50px',
              'margin': '0',
            }"
          />
        }
      </div>

      <nav>
        <div class="content">
          <p class="body-12-bold">{{ 'PORTFOLIO_MANAGER' | translate }}</p>

          <div class="content__links">
            @for (link of walletManagerLinks; track link.label) {
              <app-navigation-tile [link]="link"></app-navigation-tile>
            }
          </div>
        </div>

        <div class="content">
          <p class="body-12-bold">{{ 'TAX' | translate }}</p>

          <div class="content__links">
            @for (link of taxationLinks; track link.label) {
              <app-navigation-tile [link]="link"></app-navigation-tile>
            }
          </div>
        </div>

        @if (userFeatures?.length > 0 && user.fiscalResidency === 'FR') {
          <div class="content">
            <p class="body-12-bold">{{ 'EARLY_ACCESS' | translate }}</p>

            <div class="content__links">
              @for (link of earlyAccessLinks; track link.label) {
                @if (userFeatures.includes(link.id)) {
                  <app-navigation-tile [link]="link" [earlyAccess]="true"></app-navigation-tile>
                }
              }
            </div>
          </div>
        }
      </nav>
    </section>
  </div>

  <div>
    @if (user?.plan === 'PLN000' || user?.plan === 'PLN300') {
      <div class="smart-cta pointer" (click)="togglePlansPage()">
        <div class="smart-cta__title">
          <p class="body-12-bold">{{ 'SWITCH_TO_SMART' | translate }}</p>
          <img src="/assets/img/icons/shiny-black.svg" alt="shiny-black" />
        </div>

        <p class="smart-cta__description">
          {{ 'UNLOCK_WALTIO_EXP' | translate }}
        </p>
      </div>
    } @else {
      <div class="sponsorship pointer" [routerLink]="'/profile/sponsorship'">
        <img src="/assets/img/icons/sponsorship.svg" alt="sponsorship" />
        <p class="body-14-med">{{ 'INVITE_FRIEND' | translate }}</p>

        <div class="sponsorship__chip">
          <p class="body-13-med">{{ 'GET_15' | translate }}</p>
        </div>
      </div>
    }

    <app-plan-status
      [assessment]="assessment"
      [plan]="user.plan"
      [language]="language"
      [associatedFiscalYear]="associatedFiscalYear"
      [plansByFiscalYears]="plansByFiscalYears"
      (upgradePlan)="upgradePlan()"
      (upgradeAddon)="openAddonsDialog()"
    ></app-plan-status>

    <app-profile-sidenav [user]="user" [matMenuTriggerFor]="menu"></app-profile-sidenav>

    <mat-menu #menu="matMenu" yPosition="above" class="custom-menu">
      <div class="menu">
        <div class="item" [routerLink]="'/profile'">
          <p class="body-14-med">{{ 'PROFILE' | translate }}</p>
        </div>
        <div class="item body-14-med" [routerLink]="'/profile/preferences'">
          <p class="body-14-med">{{ 'PREFERENCES' | translate }}</p>
        </div>
        <div class="item body-14-med" [routerLink]="'/profile/subscription'">
          <p class="body-14-med">{{ 'SUBSCRIPTION' | translate }}</p>
        </div>
        <div class="item" [routerLink]="'/profile/sponsorship'">
          <p class="body-14-med">{{ 'REFERRAL' | translate }}</p>
          <div class="sponsorship-chip">{{ 30 | currency: 'EUR' : 'symbol' : '.2-2' }}</div>
        </div>
        <a class="item body-14-med" [href]="'https://help.waltio.co/' + language" target="_blank">
          <p class="body-14-med">{{ 'HELP_CENTER' | translate }}</p>
        </a>
      </div>

      <mat-divider></mat-divider>

      <div class="menu">
        <div class="action" (click)="logout()">
          <div class="action__icon-logout"></div>
          <p class="body-14-med">{{ 'LOGOUT' | translate }}</p>
        </div>
      </div>
    </mat-menu>
  </div>
</div>
